import { Component, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { AppState } from "@app/reducers";
import { clearFormControlValidators, ConfirmDialogPopupComponent, countryCodes, CrudService, CrudType, currentComponentPageBasedPermissionsSelector$, CustomDirectiveConfig, destructureAfrigisObjectAddressComponents, disableFormControls, enableFormControls, formConfigs, IAfrigisAddressComponents, IApplicationResponse, ModulesBasedApiSuffix, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams, prepareRequiredHttpParams, removeFormControlError, ResponseMessageTypes, RxjsService, setEmailValidator, setRequiredValidator, SnackbarService } from "@app/shared";
import { PrimengCustomDialogComponent } from "@app/shared/components/primeng-custom-dialog/primeng-custom-dialog.component";
import { MomentService } from "@app/shared/services/moment.service";
import { DealerModuleApiSuffixModels, DEALER_COMPONENT } from "@modules/dealer";
import { DealerBranchAddEditModel } from "@modules/dealer/models/dealer-branch.model";
import { InventoryModuleApiSuffixModels } from "@modules/inventory";
import { loggedInUserData } from "@modules/others";
import { UserLogin } from "@modules/others/models";
import { BillingModuleApiSuffixModels, DebterListComponent, NewAddressPopupComponent, SalesModuleApiSuffixModels } from "@modules/sales";
import { TechnicalMgntModuleApiSuffixModels } from "@modules/technical-management/shared/enum.ts/technical.enum";
import { select, Store } from "@ngrx/store";
import { DialogService } from "primeng/api";
import { AutoComplete } from "primeng/autocomplete";
import { combineLatest, forkJoin, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


@Component({
  selector: 'app-dealer-branch-add-edit',
  templateUrl: './dealer-branch-add-edit-component.html',
  styleUrls: ['./dealer-branch-add-edit-component.scss']
})
export class DealerBranchAddEditComponent implements OnInit {

  primengTableConfigProperties: any;
  dealerId: any;
  viewable: boolean = true;
  userData: UserLogin;
  selectedTabIndex = 0;
  dealerBranchAddEditForm: FormGroup;
  startTodayDate = new Date();
  isLoading = false;
  addressList = [];
  checkMaxLengthAddress: boolean;
  inValid = false;
  accountTypeList = [];
  bankList = [];
  commissionDropDownList = [];
  warehouseDropDownList = [];
  storageLocationWarehouseDropDownList = [];
  bankBranchesList = [];
  techAreaList = [];
  titlesList = [];
  ispostalAddressLoading: boolean;
  postalAddressList = [];
  // dsfMultipleList = [];
  physicalAddressList: any = [];
  postalAddressJsonAddress: any;
  inValidPostalAddress: boolean;
  checkMaxLengthPostalAddress: boolean;
  checkMaxLengthPhysicalAddress: boolean;
  inValidPhysicalAddress: boolean;
  showAddress: boolean;
  showPostalAddress: boolean;
  isPhysicalAddressLoading: boolean;
  dealerBranchId: string;
  params: any;
  formConfigs = formConfigs;
  dealerTypeId: any;
  referenceId: string;
  // wareHouseId: any;
  // locationId: any;
  techStocklocationId: any;
  countryCodes = countryCodes;
  isLegalEntity: boolean = false;
  isPerson: boolean = false;
  isLegalEntityPerson: boolean;
  techStockLocationNumber;
  isAnAlphaNumericOnly = new CustomDirectiveConfig({ isAnAlphaNumericOnly: true });
  isNumberOnly = new CustomDirectiveConfig({ isANumberOnly: true });
  isAnAlphaNumericWithSlash = new CustomDirectiveConfig({ isAnAlphaNumericWithSlash: true });
  comStartMonthValueName;
  bonusMonthValueName
  primengTableConfigPropertiesPageLevelAccess: any = {
    tableComponentConfigs: {
      tabsList: [
        {}, {}, {}, {}, {}
      ]
    }
  }
  isDealerTypeIdIsI = false
  avsCheckStatus = 'false';
  dealerDetails: any = {};
  isAStringOnlySpaceAnd = new CustomDirectiveConfig({ isAStringOnlySpaceAnd: true });
  dealerTypeList: any = []
  bankBranchId: any; filterData: any;
  existingDebtorDetails: any = []
  isForceFalseExistingDebtor = false;
  isDefaultSelection;
  isSelectedExistingDebtor = false;
  dealerBranchDetails: any = {}
  @ViewChild('physical', { static: false }) physicalAddressAutoComplete!: AutoComplete;
  constructor(private snackbarService: SnackbarService,
    private dialog: MatDialog, private momentService: MomentService, private router: Router,
    private activatedRoute: ActivatedRoute, private store: Store<AppState>,
    private formBuilder: FormBuilder, private rxjsService: RxjsService, private crudService: CrudService, private dialogService: DialogService) {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.dealerId = (Object.keys(params['params']).length > 0) ? params['params']['dealerId'] : '';
      this.dealerBranchId = (Object.keys(params['params']).length > 0) ? params['params']['id'] : '';
      this.dealerTypeId = (Object.keys(params['params']).length > 0) ? params['params']['dealerTypeId'] : '';
      this.referenceId = (Object.keys(params['params']).length > 0) ? params['params']['referenceId'] : '';
      this.avsCheckStatus = params['params']['avsCheckStatus'] ? params['params']['avsCheckStatus'] : 'false';
    });
    this.params = { dealerId: this.dealerId };

    this.primengTableConfigProperties = {
      tableCaption: this.dealerBranchId ? 'Update Branch' : 'Create Branch',
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Dealer Management', relativeRouterUrl: '' }, { displayName: 'Dealer Maintenance', relativeRouterUrl: '/dealer/dealer-maintenance', }, { displayName: 'Dealer Branch Details', relativeRouterUrl: '/dealer/dealer-maintenance', queryParams: { tab: 2, id: this.dealerId, dealerTypeId: this.dealerTypeId } }, { displayName: this.dealerBranchId ? 'Update Branch' : 'Create Branch', relativeRouterUrl: '', }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Dealer Branch',
            dataKey: 'branchId',
            enableBreadCrumb: true,
            enableAction: false,
            url: '',
          },
        ]
      }
    }
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    })
    if (this.referenceId) {
      this.primengTableConfigProperties.breadCrumbItems[1]['relativeRouterUrl'] = '';
      this.primengTableConfigProperties.breadCrumbItems[2]['queryParams'] = { tab: 2, id: this.dealerId, dealerTypeId: this.dealerTypeId, referenceId: this.referenceId, };
    }
  }
  ngOnInit(): void {
    this.combineLatestNgrxStoreData()
    this.createForm();
    this.loadAllDropdown();
    // this.getDsfMultiple({ IsAll: true });
    this.rxjsService.setGlobalLoaderProperty(false);
  }

  getDealerType(response: IApplicationResponse) {
    if (response.isSuccess && response.resources) {
      this.dealerTypeList = response.resources;
      let actualType = this.dealerTypeList.find(item => item.dealerTypeId == this.dealerTypeId)
      this.isDealerTypeIdIsI = false
      if (actualType?.dealerTypeName == "I") {
        this.isDealerTypeIdIsI = true;
        // this.dealerBranchAddEditForm.get('bonusMultiple').clearValidators();
        // this.dealerBranchAddEditForm.get('bonusMultiple').updateValueAndValidity();
        // this.dealerBranchAddEditForm.get('dsfMultiple').clearValidators();
        // this.dealerBranchAddEditForm.get('dsfMultiple').updateValueAndValidity();
        // this.dealerBranchAddEditForm.get('bonusMultipleStartDate').clearValidators();
        // this.dealerBranchAddEditForm.get('bonusMultipleStartDate').updateValueAndValidity();
        // this.dealerBranchAddEditForm.updateValueAndValidity();
      }
    }
  }
  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      let permission = response[0][DEALER_COMPONENT.DEALER_MAINTENANCE]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigPropertiesPageLevelAccess, permission);
        this.primengTableConfigPropertiesPageLevelAccess = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  createForm(dealerBranchAddEditModel?: DealerBranchAddEditModel) {

    let dealerTypeModel = new DealerBranchAddEditModel(dealerBranchAddEditModel);
    this.dealerBranchAddEditForm = this.formBuilder.group({});
    Object.keys(dealerTypeModel).forEach((key) => {
      if (dealerTypeModel[key] === 'object') {
        this.dealerBranchAddEditForm.addControl(key, new FormArray(dealerTypeModel[key]));
      } else {
        this.dealerBranchAddEditForm.addControl(key, new FormControl(dealerTypeModel[key]));
      }
    });
    this.dealerBranchAddEditForm.get('dealerCode').disable();
    this.dealerBranchAddEditForm.get('telePhoneNoCountryCode').disable();
    this.dealerBranchAddEditForm.get('phoneNoCountryCode').disable();
    // this.dealerBranchAddEditForm.get('debtorCode').disable();
    this.dealerBranchAddEditForm.get('phoneNoCountryCode').setValue('+27');
    this.dealerBranchAddEditForm.get('telePhoneNoCountryCode').setValue('+27');
    this.dealerBranchAddEditForm.get('branchName').setValidators([Validators.maxLength(150)]);
    // this.dealerBranchAddEditForm = setRequiredValidator(this.dealerBranchAddEditForm, ["isLegalEntityPerson", "dsfMultiple", "bonusMultiple", "companyName", "branchName", "phoneNumber", "fullAddress", "startDate", "commissionStartDate", "bankId", "techAreaId", "dealerCategoryTypeId", "firstName", "bankAccountNumber", "accountTypeId", "bankBranchId", "commissionPercentage", "streetName", "suburbName", "provinceName", "postalCode", "companyRegistrationNumber"]);
    this.dealerBranchAddEditForm = setRequiredValidator(this.dealerBranchAddEditForm, ["isLegalEntityPerson", "companyName", "branchName", "phoneNumber", "fullAddress", "startDate", "bankId", "firstName", "bankAccountNumber", "accountTypeId", "bankBranchId", "streetName", "suburbName", "provinceName", "postalCode", "companyRegistrationNumber"]);
    this.dealerBranchAddEditForm = setEmailValidator(this.dealerBranchAddEditForm, ["emailAddress", "adminEmailAddress", "accountsEmailAddress", "technicalEmailAddress"]);
    //set any one value in default
    this.dealerBranchAddEditForm.get('isLegalEntityPerson').setValue(true);
    this.dealerBranchAddEditForm = disableFormControls(this.dealerBranchAddEditForm, ["estateStreetNo", "estateStreetName", "estateName", "addressConfidentLevelName"]);
    this.isLegalEntityPerson = true;
    if (this.referenceId) {
      this.dealerBranchAddEditForm.disable();
    }
    if (this.dealerBranchId) {
      this.enableBankingDetails();
    }
    this.onValueChanges();
    this.onDealerBranchValueChanges();
  }

  onSelectPhysicalAddress(e) {
    this.onSelectedPhysicalAddressFromAutoComplete(e?.description, e, e?.seoid);
  }

  onSelectPostalAddress(e) {
    this.onSelectedAddressFromAutoComplete(e?.description, e, e?.seoid);
  }

  onSearchPhysicalAddress(val) {
    this.filterServiceTypeDetailsBySearchOptions(val?.query.trim())
      .subscribe((response: any) => {
        if (response?.isSuccess && response?.statusCode == 200) {
          this.rxjsService.setGlobalLoaderProperty(false);
          if (response.resources != null) {
            if (response?.resources[0]?.resultNotFound) {
              this.setEmptyPhysicalAddress(response?.resources[0]?.description);
            } else {
              if (this.dealerBranchAddEditForm.get('isAfrigisSearch').value) {
                this.physicalAddressList = response.resources;
              } else {
                this.physicalAddressList = response.resources;
                if (this.physicalAddressList?.length) {
                  this.physicalAddressList?.forEach(user => {
                    user.description = user?.fullAddress;
                  });
                }
              }
            }
            if (this.physicalAddressList.length == 0) {
              this.setEmptyPhysicalAddress();
            }
          } else {
            this.setEmptyPhysicalAddress();
          }
          this.ispostalAddressLoading = false;
        } else {
          this.physicalAddressList = [];
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }

  onSearchPostalAddress(val) {
    this.filterServiceTypeDetailsBySearchOptions(val?.query)
      .subscribe((response: any) => {
        if (response?.isSuccess && response?.statusCode == 200) {
          this.rxjsService.setGlobalLoaderProperty(false);
          if (response.resources != null) {
            // this.postalAddressList = response.resources;
            // if (this.postalAddressList.length == 0) {
            //   this.postalAddressList = [];
            //   this.inValidPostalAddress = true;
            //   this.dealerBranchAddEditForm.controls['latlang'].setValue('');
            // }
            //  this.postalAddressList = response.resources;
            if (response?.resources[0]?.resultNotFound) {
              this.setEmptyPostalAddress(response?.resources[0]?.description);
            } else {
              this.postalAddressList = response.resources;
            }
            if (this.postalAddressList.length == 0) {
              this.setEmptyPostalAddress();
            }
          } else {
            this.setEmptyPostalAddress();
          }
          this.ispostalAddressLoading = false;
        } else {
          this.postalAddressList = [];
        }
      });
  }

  onValueChanges() {
    this.dealerBranchAddEditForm
      .get("phoneNoCountryCode")
      .valueChanges.subscribe((phoneNoCountryCode: string) => {
        this.setPhoneNumberLengthByCountryCode(phoneNoCountryCode, "contact");
      });

    this.dealerBranchAddEditForm
      .get("telePhoneNoCountryCode")
      .valueChanges.subscribe((telePhoneNoCountryCode: string) => {
        this.setPhoneNumberLengthByCountryCode(telePhoneNoCountryCode, "contact");
      });

    this.dealerBranchAddEditForm
      .get("isLegalEntityPerson")
      .valueChanges.subscribe((val: string) => {
        this.setisLegalEntityPerson(val);
      });


    this.dealerBranchAddEditForm
      .get("phoneNumber")
      .valueChanges.subscribe((phoneNo: string) => {
        this.setPhoneNumberLengthByCountryCode(
          this.dealerBranchAddEditForm.get("phoneNoCountryCode").value,
          "contact"
        );
      });

    this.dealerBranchAddEditForm
      .get("supportPhoneNumber")
      .valueChanges.subscribe((phoneNo: string) => {
        this.setPhoneNumberLengthByCountryCode(
          this.dealerBranchAddEditForm.get("telePhoneNoCountryCode").value,
          "contact"
        );
      });
    // this.dealerBranchAddEditForm
    //   .get("techAreaId")
    //   .valueChanges.subscribe((id: string) => {
    //     if (id) {
    //       this.onChangeTechArea(id);
    //     }
    //   });
    this.dealerBranchAddEditForm
      .get("isExistingDebtor")
      .valueChanges.subscribe((boolean: boolean) => {
        if (boolean) {
          if (this.isLegalEntityPerson != this.dealerBranchDetails.isLegalEntityPerson) {
            this.dealerBranchAddEditForm.get("isExistingDebtor").setValue(false, { emitEvent: false });
            return this.snackbarService.openSnackbar(`Debtor Bank Account already linked with ${this.dealerBranchDetails.isLegalEntityPerson == true ? 'Legal Entity' : 'Person'}`)
          }
          this.isForceFalseExistingDebtor = false;
          this.setExistingDebtorDetails();
          if (!this.dealerBranchId) {
            this.disableBankingDetails();
          } else {
            this.enableBankingDetails();
          }
        } else {
          this.dealerBranchDetails.debtorId = ""
          this.isForceFalseExistingDebtor = true;
          this.clearExistingDebtorDetails();
          this.enableBankingDetails();
        }
      });
  }

  disableBankingDetails() {
    this.dealerBranchAddEditForm.get('titleId').disable();
    this.dealerBranchAddEditForm.get('firstName').disable();
    this.dealerBranchAddEditForm.get('lastName').disable();
    this.dealerBranchAddEditForm.get('companyRegistrationNumber').disable();
    this.dealerBranchAddEditForm.get('southAfricanId').disable();
    this.dealerBranchAddEditForm.get('bankId').disable();
    this.dealerBranchAddEditForm.get('accountTypeId').disable();
    this.dealerBranchAddEditForm.get('bankAccountNumber').disable();
    this.dealerBranchAddEditForm.get('bankBranchId').disable();
  }

  enableBankingDetails() {
    this.dealerBranchAddEditForm.get('titleId').enable();
    this.dealerBranchAddEditForm.get('firstName').enable();
    this.dealerBranchAddEditForm.get('lastName').enable();
    this.dealerBranchAddEditForm.get('companyRegistrationNumber').enable();
    this.dealerBranchAddEditForm.get('southAfricanId').enable();
    this.dealerBranchAddEditForm.get('bankId').enable();
    this.dealerBranchAddEditForm.get('accountTypeId').enable();
    this.dealerBranchAddEditForm.get('bankAccountNumber').enable();
    this.dealerBranchAddEditForm.get('bankBranchId').enable();
  }

  clearExistingDebtorDetails() {
    this.dealerBranchAddEditForm.patchValue({
      titleId: null,
      firstName: "",
      lastName: "",
      southAfricanId: "",
      bankId: null,
      debtorAccountDetailId: "",
      accountTypeId: null,
      bankAccountNumber: "",
      bankBranchId: null,
      debtorId: "",
      bankBranchCode: "",
      companyRegistrationNumber: "",
      isExistingDebtor: false
    }, { emitEvent: false, onlySelf: true })
  }

  setExistingDebtorDetails() {
    if (this.existingDebtorDetails) {
      this.isDefaultSelection = this.dealerBranchAddEditForm.get("isLegalEntityPerson").value
      this.dealerBranchDetails.debtorId = this.existingDebtorDetails.debtorId
      this.dealerBranchAddEditForm.patchValue({
        ...this.existingDebtorDetails
      }, { emitEvent: false, onlySelf: true })
    } else {
      this.snackbarService.openSnackbar("No Debtor found")
    }
  }

  setisLegalEntityPerson(val, isFirstTime = false) {
    if (this.isDefaultSelection === undefined) {
      this.isDefaultSelection = !isFirstTime ? !val : val
    }
    if (val == 'true' || val == true) {
      if (!isFirstTime) { this.clearValues(["titleId", "firstName"]) }
      this.isLegalEntityPerson = true;
      this.dealerBranchAddEditForm = setRequiredValidator(this.dealerBranchAddEditForm, ["companyRegistrationNumber", "firstName"]);
      this.dealerBranchAddEditForm = clearFormControlValidators(this.dealerBranchAddEditForm, ["southAfricanId", "titleId", "lastName"])
      this.dealerBranchAddEditForm.updateValueAndValidity();

    }
    else {
      if (!isFirstTime) { this.clearValues(["titleId", "firstName"]) }
      this.isLegalEntityPerson = false;
      this.dealerBranchAddEditForm = setRequiredValidator(this.dealerBranchAddEditForm, ["southAfricanId", "titleId", "firstName", "lastName"]);
      this.dealerBranchAddEditForm.get('companyRegistrationNumber').clearValidators();
      this.dealerBranchAddEditForm.get('companyRegistrationNumber').updateValueAndValidity();
      this.dealerBranchAddEditForm.updateValueAndValidity();
    }

    if (!isFirstTime) {
      if (this.isDefaultSelection == val) {
        this.dealerBranchAddEditForm.get('titleId').setValue(this.dealerBranchDetails.titleId);
        this.dealerBranchAddEditForm.get('firstName').setValue(this.dealerBranchDetails.firstName);
      }
      if (this.isDefaultSelection === val && !this.isForceFalseExistingDebtor) {
        if (this.dealerBranchAddEditForm.get('isExistingDebtor').value || this.isSelectedExistingDebtor) {
          this.setExistingDebtorDetails();
        }
      } else {
        if (this.dealerBranchAddEditForm.get('isExistingDebtor').value) {
          this.clearExistingDebtorDetails();
        }
      }
    }
  }
  clearValues(arr) {
    arr.forEach(item => {
      this.dealerBranchAddEditForm.get(item).setValue(null);
    })

  }

  openDebterExistModal(data) {
    data?.forEach(element => {
      element['isDealer'] = true;
    });
    const dialogReff = this.dialog.open(DebterListComponent, { width: '960px', data: data, disableClose: true });
    dialogReff.componentInstance.outputData1.subscribe(ele => {
      if (ele && !ele.isSkipDebtor) {
        if (this.dealerBranchDetails?.debtorId) {
          let customText = `The bank account is already linked with <b>${this.dealerBranchDetails?.isLegalEntityPerson ? 'Legal Entity' : 'Person'}</b>. Would you like to override it with the bank details of a <b>${this.isLegalEntityPerson ? 'Legal Entity' : "Person"}</b>`
          const confirm = this.dialogService.open(PrimengCustomDialogComponent, {
            header: 'Confirmation',
            showHeader: false,
            closable: true,
            baseZIndex: 1000,
            width: '500px',
            data: { customText: customText },
          });
          confirm.onClose.subscribe((resp) => {
            if (resp === false) {
              this.getDepterIdDetails(ele.debtorId, ele.debtorAccountDetailId);
              this.dealerBranchDetails.isLegalEntityPerson = this.isLegalEntityPerson;
              this.isDefaultSelection = this.isLegalEntityPerson;
            }
          })
        } else {
          this.getDepterIdDetails(ele.debtorId, ele.debtorAccountDetailId);
          this.dealerBranchDetails.isLegalEntityPerson = this.isLegalEntityPerson;
          this.isDefaultSelection = this.isLegalEntityPerson;
        }
      } else if (ele && ele.isSkipDebtor) {
        this.onSubmit(true);
      }

    });
  }

  getDepterIdDetails(id, debtorAccountDetailId) {
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.SALES_API_DEBTER_DETAILS, undefined, false, prepareGetRequestHttpParams(null, null, {
      debtorId: id,
      debtorAccountDetailId: debtorAccountDetailId || "",
      isLinkDebtor: true
    })).subscribe((response: IApplicationResponse) => {
      this.rxjsService.setGlobalLoaderProperty(false);
      if (response.isSuccess && response.statusCode === 200 && response.resources) {
        let dataFromLinkDEbtor = response.resources;
        this.existingDebtorDetails = {
          titleId: dataFromLinkDEbtor.titleId,
          firstName: dataFromLinkDEbtor.firstName,
          lastName: dataFromLinkDEbtor.lastName,
          southAfricanId: dataFromLinkDEbtor.said,
          bankId: dataFromLinkDEbtor.bankId,
          debtorAccountDetailId: dataFromLinkDEbtor.debtorAccountDetailId,
          accountTypeId: dataFromLinkDEbtor.accountTypeId,
          bankAccountNumber: dataFromLinkDEbtor.accountNo,
          bankBranchId: dataFromLinkDEbtor.bankBranchId,
          debtorId: id,
          bankBranchCode: dataFromLinkDEbtor.bankBranchCode,
          isExistingDebtor: true,
          companyRegistrationNumber: dataFromLinkDEbtor.companyRegNo,
        };
        this.dealerBranchDetails = { ...this.dealerBranchDetails, debtorId: id }
        if (dataFromLinkDEbtor.bankId) {
          this.onChangeBank(dataFromLinkDEbtor.bankId);
        }
        this.isSelectedExistingDebtor = true;
        this.isForceFalseExistingDebtor = false;
        this.dealerBranchAddEditForm.patchValue({
          ...this.existingDebtorDetails
        }, { emitEvent: false })
        if (!this.dealerBranchId) {
          this.disableBankingDetails();
        } else {
          this.enableBankingDetails();
        }
        this.rxjsService.setGlobalLoaderProperty(false);

      }
    })
  }

  setPhoneNumberLengthByCountryCode(countryCode: string, str: string) {
    switch (countryCode) {
      case "+27":
        if (str == "contact") {
          this.dealerBranchAddEditForm
            .get("phoneNumber")
            .setValidators([
              Validators.minLength(
                formConfigs.southAfricanContactNumberMaxLength
              ),
              Validators.maxLength(
                formConfigs.southAfricanContactNumberMaxLength
              ),
            ]);
        }

        break;
      default:
        if (str == "contact") {
          this.dealerBranchAddEditForm
            .get("phoneNumber")
            .setValidators([
              Validators.minLength(formConfigs.indianContactNumberMaxLength),
              Validators.maxLength(formConfigs.indianContactNumberMaxLength),
            ]);
        }
        break;
    }
  }
  onDealerBranchValueChanges() {
    this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').valueChanges.pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((response: any) => {
        if (response == true) {
          const postalAddress1 = (this.dealerBranchAddEditForm.get('buildingNo').value ? this.dealerBranchAddEditForm.get('buildingNo').value + ' ' : '') + (this.dealerBranchAddEditForm.get('buildingName').value ? this.dealerBranchAddEditForm.get('buildingName').value + ' ' : '') + (this.dealerBranchAddEditForm.get('streetNo').value ? this.dealerBranchAddEditForm.get('streetNo').value + ' ' : '') + (this.dealerBranchAddEditForm.get('streetName').value ? this.dealerBranchAddEditForm.get('streetName').value : '');
          const postalAddress2 = (this.dealerBranchAddEditForm.get('suburbName').value ? this.dealerBranchAddEditForm.get('suburbName').value : '');
          const postalAddress3 = this.dealerBranchAddEditForm.get('cityName')?.value != null ? this.dealerBranchAddEditForm.get('cityName')?.value : '';
          const postalAddress4 = this.dealerBranchAddEditForm.get('provinceName')?.value != null ? this.dealerBranchAddEditForm.get('provinceName')?.value : '';
          const postalAddress5 = this.dealerBranchAddEditForm.get('postalCode')?.value != null ? this.dealerBranchAddEditForm.get('postalCode')?.value : '';
          this.dealerBranchAddEditForm.get('postalAddress1').setValue(postalAddress1);
          this.dealerBranchAddEditForm.get('postalAddress2').setValue(postalAddress2);
          this.dealerBranchAddEditForm.get('postalAddress3').setValue(postalAddress3);
          this.dealerBranchAddEditForm.get('postalAddress4').setValue(postalAddress4);
          this.dealerBranchAddEditForm.get('postalAddress5').setValue(postalAddress5);
          // this.postalAddressList = this.physicalAddressList;
          // this.setSameAsPhysicalAddress();
          // this.enableDisablePostalAddress(response);
        } else if (response == false) {

          this.dealerBranchAddEditForm.get("postalAddress1").reset();
          this.dealerBranchAddEditForm.get("postalAddress2").reset();
          this.dealerBranchAddEditForm.get("postalAddress3").reset();
          this.dealerBranchAddEditForm.get("postalAddress4").reset();
          this.dealerBranchAddEditForm.get("postalAddress5").reset();
          // this.enableDisablePostalAddress(response);
        }
      });

    this.dealerBranchAddEditForm.get('isSameAsDealerAddress').valueChanges.subscribe((response: any) => {

      if (response) {
        let latLong = "";
        if (this.dealerDetails.latitude && this.dealerDetails.longitude) {
          latLong = this.dealerDetails.latitude + "," + this.dealerDetails.longitude
        }
        this.dealerBranchAddEditForm.get("fullAddress").setValue({ description: this.dealerDetails.formatedAddress });
        this.dealerBranchAddEditForm.get("buildingNo").setValue(this.dealerDetails?.buildingNo);
        this.dealerBranchAddEditForm.get("buildingName").setValue(this.dealerDetails?.buildingName);
        this.dealerBranchAddEditForm.get("streetNo").setValue(this.dealerDetails.streetNo);
        this.dealerBranchAddEditForm.get("streetName").setValue(this.dealerDetails.streetName);
        this.dealerBranchAddEditForm.get("suburbName").setValue(this.dealerDetails.suburbName);
        this.dealerBranchAddEditForm.get("cityName").setValue(this.dealerDetails.cityName);
        this.dealerBranchAddEditForm.get("provinceName").setValue(this.dealerDetails.provinceName);
        this.dealerBranchAddEditForm.get("provinceId").setValue(this.dealerDetails.provinceId);
        this.dealerBranchAddEditForm.get("postalCode").setValue(this.dealerDetails.postalCode);
        this.dealerBranchAddEditForm.get("physicalAddressId").setValue(this.dealerDetails.physicalAddressId);
        this.dealerBranchAddEditForm.get("latitude").setValue(this.dealerDetails.latitude);
        this.dealerBranchAddEditForm.get("longitude").setValue(this.dealerDetails.longitude);
        this.dealerBranchAddEditForm.get("latLong").setValue(latLong);
        this.dealerBranchAddEditForm.get("estateName").setValue(this.dealerDetails?.estateName);
        this.dealerBranchAddEditForm.get("estateStreetNo").setValue(this.dealerDetails?.estateStreetNo);
        this.dealerBranchAddEditForm.get("estateStreetName").setValue(this.dealerDetails?.estateStreetName);
        this.dealerBranchAddEditForm.get("addressConfidentLevelName").setValue(this.dealerDetails?.addressConfidentLevelName);
        this.dealerBranchAddEditForm.get("addressConfidentLevelId").setValue(this.dealerDetails?.addressConfidentLevelId);
        this.setSameAsPhysicalAddress();
      } else {
        this.dealerBranchAddEditForm.get("fullAddress").reset();
        this.dealerBranchAddEditForm.get("buildingNo").reset();
        this.dealerBranchAddEditForm.get("buildingName").reset();
        this.dealerBranchAddEditForm.get("streetNo").reset();
        this.dealerBranchAddEditForm.get("streetName").reset();
        this.dealerBranchAddEditForm.get("suburbName").reset();
        this.dealerBranchAddEditForm.get("cityName").reset();
        this.dealerBranchAddEditForm.get("provinceName").reset();
        this.dealerBranchAddEditForm.get("provinceId").reset();
        this.dealerBranchAddEditForm.get("postalCode").reset();
        this.dealerBranchAddEditForm.get("physicalAddressId").reset();
        this.dealerBranchAddEditForm.get("latitude").reset();
        this.dealerBranchAddEditForm.get("longitude").reset();
        this.dealerBranchAddEditForm.get("latLong").reset();
        this.dealerBranchAddEditForm.get("estateName").reset();
        this.dealerBranchAddEditForm.get("estateStreetNo").reset();
        this.dealerBranchAddEditForm.get("estateStreetName").reset();
        this.dealerBranchAddEditForm.get("addressConfidentLevelName").reset();
        this.dealerBranchAddEditForm.get("addressConfidentLevelId").reset();
      }
    })
    this.dealerBranchAddEditForm.get("isAddressComplex").valueChanges.subscribe((isAddressComplex: boolean) => {
      this.onAfterComplexAddress();
    });
    this.dealerBranchAddEditForm.get('buildingNo').valueChanges.pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((response: any) => {
        if (response && this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
          this.dealerBranchAddEditForm.get('postalBuildingNo').setValue(response);
        } else if (this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
          this.dealerBranchAddEditForm.get('postalBuildingNo').setValue(response);
        }
        if (this.dealerBranchAddEditForm.get("isAddressComplex").value) {
          this.onAfterComplexAddress();
        }
      });
    this.dealerBranchAddEditForm.get('buildingName').valueChanges.pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((response: any) => {
        if (response && this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
          this.dealerBranchAddEditForm.get('postalBuildingName').setValue(response);
        } else if (this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
          this.dealerBranchAddEditForm.get('postalBuildingName').setValue(response);
        }
        if (this.dealerBranchAddEditForm.get("isAddressComplex").value) {
          this.onAfterComplexAddress();
        }
      });
    this.dealerBranchAddEditForm.get("isAddressExtra").valueChanges.subscribe((isAddressExtra: boolean) => {
      if (isAddressExtra) {
        this.dealerBranchAddEditForm = enableFormControls(
          this.dealerBranchAddEditForm,
          ["estateStreetNo", "estateStreetName", "estateName"]
        );
      } else {
        this.dealerBranchAddEditForm = disableFormControls(
          this.dealerBranchAddEditForm,
          ["estateStreetNo", "estateStreetName", "estateName"]
        );
        this.dealerBranchAddEditForm.get("estateStreetNo").setValue(null);
        this.dealerBranchAddEditForm.get("estateStreetName").setValue(null);
        this.dealerBranchAddEditForm.get("estateName").setValue(null);
        this.dealerBranchAddEditForm.get("addressConfidentLevelName").setValue(null);
        this.dealerBranchAddEditForm.get("addressConfidentLevelId").setValue(null);
      }
      this.onAfterExtraAddress();
    });
    this.dealerBranchAddEditForm.get('estateStreetNo').valueChanges.subscribe((estateStreetNo) => {
      if (estateStreetNo && this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
        this.dealerBranchAddEditForm.get('postalEstateStreetNo').setValue(estateStreetNo);
      } else if (this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
        this.dealerBranchAddEditForm.get('postalEstateStreetNo').setValue(estateStreetNo);
      }
      this.onAfterExtraAddress();
    });
    this.dealerBranchAddEditForm.get('estateStreetName').valueChanges.subscribe((estateStreetName) => {
      if (estateStreetName && this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
        this.dealerBranchAddEditForm.get('postalEstateStreetName').setValue(estateStreetName);
      } else if (this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
        this.dealerBranchAddEditForm.get('postalEstateStreetName').setValue(estateStreetName);
      }
      this.onAfterExtraAddress();
    });
    this.dealerBranchAddEditForm.get('estateName').valueChanges.subscribe((estateName) => {
      if (estateName && this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
        this.dealerBranchAddEditForm.get('postalEstateName').setValue(estateName);
      } else if (this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
        this.dealerBranchAddEditForm.get('postalEstateName').setValue(estateName);
      }
      this.onAfterExtraAddress();
    });
    this.dealerBranchAddEditForm.get('isAfrigisSearch').valueChanges.pipe(distinctUntilChanged(), debounceTime(700))
      .subscribe((isAfrigisSearch: boolean) => {
        this.focusAndOpenPhysicalAddress()
        // this.dealerBranchAddEditForm.get('formatedAddress').setValue(this.dealerBranchAddEditForm.get('formatedAddress').value);
        if (isAfrigisSearch) {
          this.dealerBranchAddEditForm.get('physicalAddressId').setValue(this.dealerBranchAddEditForm.get('physicalAddressId').value ?
            this.dealerBranchAddEditForm.get('physicalAddressId').value : "");
          this.dealerBranchAddEditForm.get('latLong').setValidators([Validators.required]);
          this.dealerBranchAddEditForm.get('latLong').updateValueAndValidity();
          this.clearAddressFormGroupValues();
        } else {
          this.dealerBranchAddEditForm.get('latLong').clearValidators();
          this.dealerBranchAddEditForm.get('latLong').updateValueAndValidity();
        }
      });
  }
  focusAndOpenPhysicalAddress() {
    if (this.physicalAddressAutoComplete) {
      this.physicalAddressAutoComplete.focusInput();
    }
    // 👈 opens suggestion panel
    const searchText = this.dealerBranchAddEditForm.get('fullAddress').value?.description || this.dealerBranchAddEditForm.get('fullAddress').value;
    this.physicalAddressAutoComplete.search('', searchText);
  }
  clearAddressFormGroupValues(): void {
    this.dealerBranchAddEditForm.patchValue({
      latitude: null,
      longitude: null,
      latLong: null,
      suburbName: null,
      cityName: null,
      provinceName: null,
      provinceId: null,
      postalCode: null,
      streetName: null,
      streetNo: null,
      buildingNo: null,
      buildingName: null,
      estateName: null,
      estateStreetName: null,
      estateStreetNo: null,
      addressConfidentLevelName: '',
      addressConfidentLevelId: '',
    });
  }
  onAfterComplexAddress() {
    if (this.dealerBranchAddEditForm.get('isAddressComplex').value && !this.dealerBranchAddEditForm.get("buildingNo").value && !this.dealerBranchAddEditForm.get("buildingName").value) {
      this.dealerBranchAddEditForm.get("buildingNo").setErrors({ atleastOneOfTheFieldsIsRequired: true }, { emitEvent: false });
      this.dealerBranchAddEditForm.get("buildingName").setErrors({ atleastOneOfTheFieldsIsRequired: true }, { emitEvent: false });
    } else {
      this.dealerBranchAddEditForm = removeFormControlError(this.dealerBranchAddEditForm, "atleastOneOfTheFieldsIsRequired", "buildingNo");
      this.dealerBranchAddEditForm = removeFormControlError(this.dealerBranchAddEditForm, "atleastOneOfTheFieldsIsRequired", "buildingName");
    }
  }

  onAfterExtraAddress() {
    if (this.dealerBranchAddEditForm.get('isAddressExtra').value &&
      !this.dealerBranchAddEditForm.get("estateStreetNo").value &&
      !this.dealerBranchAddEditForm.get("estateStreetName").value &&
      !this.dealerBranchAddEditForm.get("estateName").value) {
      this.dealerBranchAddEditForm.get("estateStreetNo").setErrors({ atleastOneOfTheFieldsIsRequired: true }, { emitEvent: false });
      this.dealerBranchAddEditForm.get("estateStreetName").setErrors({ atleastOneOfTheFieldsIsRequired: true }, { emitEvent: false });
      this.dealerBranchAddEditForm.get("estateName").setErrors({ atleastOneOfTheFieldsIsRequired: true }, { emitEvent: false });
    } else {
      this.dealerBranchAddEditForm = removeFormControlError(this.dealerBranchAddEditForm, "atleastOneOfTheFieldsIsRequired", "estateStreetNo");
      this.dealerBranchAddEditForm = removeFormControlError(this.dealerBranchAddEditForm, "atleastOneOfTheFieldsIsRequired", "estateStreetName");
      this.dealerBranchAddEditForm = removeFormControlError(this.dealerBranchAddEditForm, "atleastOneOfTheFieldsIsRequired", "estateName");
    }
  }
  setSameAsPhysicalAddress() {
    if (this.dealerBranchAddEditForm.get('isSameAsPhysicalAddress').value) {
      this.dealerBranchAddEditForm.patchValue({
        postalAddressId: this.dealerBranchAddEditForm.get('physicalAddressId').value,
        postalSuburbName: this.dealerBranchAddEditForm.get('suburbName').value, postalCityName: this.dealerBranchAddEditForm.get('cityName').value,
        postalProvinceName: this.dealerBranchAddEditForm.get('provinceName').value, postalPostalCode: this.dealerBranchAddEditForm.get('postalCode').value,
        postalStreetName: this.dealerBranchAddEditForm.get('streetName').value, postalStreetNo: this.dealerBranchAddEditForm.get('streetNo').value,
        postalBuildingName: this.dealerBranchAddEditForm.get('buildingName').value, postalBuildingNo: this.dealerBranchAddEditForm.get('buildingNo').value,
        postalLatitude: this.dealerBranchAddEditForm.get('latitude').value, postalLongitude: this.dealerBranchAddEditForm.get('longitude').value,
        postalseoId: this.dealerBranchAddEditForm.get('seoId').value, postalJsonObject: this.dealerBranchAddEditForm.get('jsonObject').value,
        postalEstateName: this.dealerBranchAddEditForm.get('estateName').value, postalEstateStreetNo: this.dealerBranchAddEditForm.get('estateStreetNo').value,
        postalEstateStreetName: this.dealerBranchAddEditForm.get('estateStreetName').value, postalAddressConfidentLevelName: this.dealerBranchAddEditForm.get('addressConfidentLevelName').value,
      }, { emitEvent: false })
      this.dealerBranchAddEditForm.get('postalFullAddress').setValue(this.dealerBranchAddEditForm.get('fullAddress').value, { emitEvent: false });
      this.dealerBranchAddEditForm.get('postalFullAddress').disable();
    } else {
      this.dealerBranchAddEditForm.get('postalFullAddress').enable();
    }
  }
  getDealerDetails(data: IApplicationResponse) {
    if (data.isSuccess && data.statusCode == 200) {
      this.dealerDetails = data.resources
      if (data.resources.companyName) {
        this.dealerBranchAddEditForm.get('companyName').setValue(data.resources.companyName);
        this.dealerBranchAddEditForm.get('companyName').disable();
      }
      if (data.resources.dealerIIPCode) {
        this.dealerBranchAddEditForm.get('dealerCode').setValue(data.resources.dealerIIPCode);
        this.dealerBranchAddEditForm.get('dealerCode').disable();
      }
      if (!this.referenceId && (data?.resources?.approvalStatus?.toLowerCase() != 'approved' || !data?.resources?.approvalStatus)) {
        this.viewable = false;
      } else if (this.dealerBranchId && data?.resources?.approvalStatus?.toLowerCase() == 'approved') {
        // this.dealerBranchAddEditForm.disable();
        this.viewable = false;
      }
    }
  }
  // getDsfMultiple(params) {
  //   this.crudService.get(
  //     ModulesBasedApiSuffix.DEALER,
  //     DealerModuleApiSuffixModels.UX_DSF_CONFIG,
  //     undefined,
  //     false, prepareRequiredHttpParams(params)
  //   ).subscribe(data => {
  //     if (data.isSuccess && data.statusCode == 200) {
  //       this.dsfMultipleList = data.resources;
  //     }

  //   });
  // }
  loadAllDropdown() {
    let api = [this.crudService.dropdown(ModulesBasedApiSuffix.BILLING, SalesModuleApiSuffixModels.UX_ACCOUNT_TYPES),
    this.crudService.get(ModulesBasedApiSuffix.BILLING, BillingModuleApiSuffixModels.UX_BANKS, undefined,
      false, prepareRequiredHttpParams(this.params)),
    this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_CATEGORY, undefined,
      false, prepareRequiredHttpParams(this.params)),
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.UX_AREAS, undefined,
      false, prepareRequiredHttpParams({ ...this.params, isDescription: true })),
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_UX_TITLES, undefined,
      false, prepareRequiredHttpParams(this.params)),
    this.crudService.dropdown(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_TYPE_LIST,
      prepareRequiredHttpParams({ IsAll: false })),
    this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER, this.dealerId)
    ]
    if (this.dealerBranchId) {
      api.push(this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH, this.dealerBranchId, false,
        prepareRequiredHttpParams({ dealerId: this.dealerId })))
    }
    forkJoin(api).subscribe(response => {
      response?.forEach((data: IApplicationResponse, ix: number) => {
        if (data.isSuccess && data.statusCode == 200) {
          switch (ix) {
            case 0:
              this.accountTypeList = data.resources;
              break;
            case 1:
              this.bankList = data.resources;
              break;
            case 2:
              this.commissionDropDownList = data.resources;
              break;
            case 3:
              this.techAreaList = data.resources;
              break;
            case 4:
              this.titlesList = data.resources;
              break;
            case 5:
              this.getDealerType(data);
              break;
            case 6:
              this.getDealerDetails(data);
              break;
            case 7:
              this.dealerBranchDetails = data.resources;
              this.setValue(data.resources);
              break;
          }
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    });
  }

  getStorageLocationDropdown() {
    //IsAll=true
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.UX_STORAGE_LOCATION_WAREHOUSE,
      undefined,
      false, prepareRequiredHttpParams(this.params)
    ).subscribe(data => {
      if (data.isSuccess && data.statusCode == 200) {
        this.storageLocationWarehouseDropDownList = data.resources;
      }

    });
  }
  getBankBranches(otherParams) {
    this.crudService.get(
      ModulesBasedApiSuffix.BILLING,
      BillingModuleApiSuffixModels.UX_BANK_BRANCHES,
      undefined,
      false, prepareRequiredHttpParams(otherParams)
    ).subscribe(data => {
      if (data.isSuccess && data.statusCode == 200) {
        this.bankBranchesList = data.resources;
        if (this.bankBranchesList && this.bankBranchesList.length == 0)
          this.snackbarService.openSnackbar("Please try selecting bank which has branch", ResponseMessageTypes.WARNING);

      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }
  getDealerBranchDetails(otherParams) {
    if (this.dealerBranchId) {
      this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH, this.dealerBranchId, false,
        prepareRequiredHttpParams(otherParams))
        .subscribe((response: IApplicationResponse) => {
          if (response && response.resources && response.isSuccess) {
            this.dealerBranchDetails = response.resources;
            this.setValue(response.resources);
          }
        });
    }
  }
  onchangeCommision(values, otherParams?: any, type?: any) {
    if (!this.dealerBranchAddEditForm.get('startDate').value && type == 'manual') {
      // this.dealerBranchAddEditForm.get("dealerCategoryTypeId").setValue(null);
      return this.snackbarService.openSnackbar("Please select the start date first");
    }
    // otherParams = { dealerTypeId: this.dealerTypeId, dealerCategoryTypeId: values }
    if (values) {

      this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY, null, false,
        prepareRequiredHttpParams(otherParams))
        .subscribe((response: IApplicationResponse) => {
          if (response && response.resources && response.isSuccess) {
            if (response.resources.commission == null || response.resources.monthValueName == null || response.resources.dsfValue == null)
              this.snackbarService.openSnackbar("Please try selecting any other Commission Type ", ResponseMessageTypes.WARNING);

            // this.dealerBranchAddEditForm.get("commissionPercentage").setValue(response.resources.commission);
            // this.dealerBranchAddEditForm.get("bonusMultiple").setValue(response.resources.monthValueName);
            // this.dealerBranchAddEditForm.get("dsfMultiple").setValue(response.resources.dsfValue);
            // if (type == 'manual')
            //   this.dealerBranchAddEditForm.get("bonusMultiple").setValue(0);

            if (type == 'manual' && response.resources.monthValueName != "0") {
              this.bonusMonthValueName = parseInt(response.resources.monthValueName);
              let formValue = this.dealerBranchAddEditForm.getRawValue();
              if (formValue.startDate) {
                formValue.startDate = (formValue.startDate && formValue.startDate != null) ? this.momentService.toMoment(formValue.startDate).format('YYYY-MM-DDThh:mm:ss[Z]') : null;
                var newDate = new Date(formValue.startDate);
                newDate.setMonth(newDate.getMonth() + this.bonusMonthValueName)
                // this.dealerBranchAddEditForm.get("bonusMultipleStartDate").setValue(newDate);
              }
            } else {
              // if (type != "set") {
              //   this.dealerBranchAddEditForm.get("bonusMultipleStartDate").setValue(null);
              // }
            }
            if (type == 'manual' && response.resources.comStartMonthValueName) {
              this.comStartMonthValueName = parseInt(response.resources.comStartMonthValueName);
              let formValue = this.dealerBranchAddEditForm.getRawValue();
              if (formValue.startDate) {
                formValue.startDate = (formValue.startDate && formValue.startDate != null) ? this.momentService.toMoment(formValue.startDate).format('YYYY-MM-DDThh:mm:ss[Z]') : null;
                var newDate1 = new Date(formValue.startDate);
                newDate1.setMonth(newDate1.getMonth() + this.comStartMonthValueName)

                // this.dealerBranchAddEditForm.get("commissionStartDate").setValue(newDate1);
              }
            }
          } else {
            this.snackbarService.openSnackbar("Please try selecting any other Commission Type ", ResponseMessageTypes.WARNING);
            // this.dealerBranchAddEditForm.get("commissionPercentage").setValue(null);
            // this.dealerBranchAddEditForm.get("bonusMultiple").setValue(null);
            // this.dealerBranchAddEditForm.get("dsfMultiple").setValue(null);
            // this.dealerBranchAddEditForm.get("bonusMultipleStartDate").setValue(null);
            // this.dealerBranchAddEditForm.get("commissionStartDate").setValue(null);
            // this.dealerBranchAddEditForm.get("dealerCategoryTypeId").setValue(null);
            this.comStartMonthValueName = 0;
            this.bonusMonthValueName = 0;
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        });
    }
  }
  param: any
  // onChangeTechArea(techId) {
  //   if (techId && this.dealerBranchId) {
  //     this.onValidateTechArea(techId);
  //   } else if (techId) {
  //     // this.onLoadTechAreaDetails(techId);
  //   }
  // }

  onValidateTechArea(techId) {
    if (techId) {
      this.rxjsService.setGlobalLoaderProperty(true);
      this.crudService.get(
        ModulesBasedApiSuffix.DEALER,
        DealerModuleApiSuffixModels.DEALER_BRANCH_TECHAREA_VALIDATION,
        undefined,
        false, prepareRequiredHttpParams({ dealerBranchId: this.dealerBranchId, techAreaId: techId })
      ).subscribe(data => {
        if (data.isSuccess && data.statusCode == 200) {
          if (data.resources?.isSuccess) {
            // this.onLoadTechAreaDetails(techId);
          } else if (!data.resources?.isSuccess) {
            const dialogData = {
              title: 'Alert',
              message: data.resources.validateMessage,
              isClose: true,
              isAlert: true,
              msgCenter: true,
            }
            this.openConfirmDialog(dialogData);
          }
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    }
  }

  // onLoadTechAreaDetails(techId) {
  //   if (techId && techId != 'Null') {
  //     this.rxjsService.setGlobalLoaderProperty(true);
  //     this.crudService.get(
  //       ModulesBasedApiSuffix.TECHNICIAN,
  //       DealerModuleApiSuffixModels.DEALER_TECH_AREA_DETAILS,
  //       undefined,
  //       false, prepareRequiredHttpParams({ techAreaId: techId })
  //     ).subscribe(data => {
  //       if (data.isSuccess && data.statusCode == 200 && data.resources) {
  //         let techResult = data.resources;
  //         // this.dealerBranchAddEditForm.get('warehouseId').setValue(techResult.warehouseName);
  //         // this.dealerBranchAddEditForm.get('locationId').setValue(techResult.storageLocationName);
  //         // this.wareHouseId = techResult.warehouseId;
  //         this.locationId = techResult?.storageLocationId
  //       } else {
  //         // this.dealerBranchAddEditForm.get('warehouseId').setValue(null);
  //         // this.dealerBranchAddEditForm.get('locationId').setValue(null);
  //       }
  //       this.rxjsService.setGlobalLoaderProperty(false);
  //     });
  //   }
  // }

  openConfirmDialog(dialogData) {
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      width: "500px",
      data: dialogData,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (!dialogResult) {
        this.getDealerBranchDetails({ "dealerId": this.dealerId });
      } else {
        // this.onLoadTechAreaDetails(this.dealerBranchAddEditForm.get("techAreaId").value);
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  bankParam: any
  onChangeBank(event) {
    let bankId = event ? event : null;
    if (bankId) {
      this.bankParam = { ...{ bankId: bankId } };
      this.dealerBranchAddEditForm.get("bankBranchId").setValue(null);
      this.dealerBranchAddEditForm.get("bankBranchCode").setValue('');
      this.getBankBranches(this.bankParam);
    }
  }

  onChangeBankBranch(events) {
    this.bankBranchId = events;
    if (this.bankBranchesList && this.bankBranchesList.length > 0) {
      this.filterData = this.bankBranchesList.filter(x => x.id == this.bankBranchId);
      if (this.filterData && this.filterData.length > 0)
        this.dealerBranchAddEditForm.get("bankBranchCode").setValue(this.filterData[0].bankBranchCode);
    }
  }
  setValue(response) {
    this.dealerBranchAddEditForm.get("startDate").setValue(response.startDate ? new Date(response.startDate) : null);
    this.dealerBranchAddEditForm.get("endDate").setValue(response.endDate ? new Date(response.endDate) : null);
    // this.dealerBranchAddEditForm.get("dealerCategoryTypeId").setValue(response.dealerCategoryTypeId);
    // if (response.dealerCategoryTypeId) {
    //   this.onchangeCommision(response.dealerCategoryTypeId, null, 'set');
    // }
    if (response.bankId) {
      this.onChangeBank(response.bankId);
    }
    // if (response.techAreaId) {
    //   this.onLoadTechAreaDetails(response.techAreaId);
    // }
    if (response.isExistingDebtor) {
      this.existingDebtorDetails = {
        titleId: response.titleId,
        firstName: response.firstName,
        lastName: response.lastName,
        southAfricanId: response.southAfricanId,
        bankId: response.bankId,
        debtorAccountDetailId: response.debtorAccountDetailId,
        accountTypeId: response.accountTypeId,
        bankAccountNumber: response.accountNo,
        bankBranchId: response.bankBranchId,
        bankBranchCode: response.bankBranchCode,
        debtorId: response.debtorId,
        companyRegistrationNumber: response.companyRegistrationNumber,
        isExistingDebtor: true
      }
      this.isSelectedExistingDebtor = true;
    }
    this.dealerBranchAddEditForm.patchValue({ ...this.existingDebtorDetails }, { emitEvent: false })
    this.techStocklocationId = response.techStockLocationId;
    let latLong = "";
    if (response?.latitude && response?.longitude) {
      latLong = `${response?.latitude}, ${response?.longitude}`;
    }
    this.dealerBranchAddEditForm.get("latLong").setValue(response?.latLong || latLong);
    // this.dealerBranchAddEditForm.get("dealerCode").setValue(this.dealerCode);
    this.dealerBranchAddEditForm.get("bankBranchId").setValue(response.bankBranchId);
    this.dealerBranchAddEditForm.get("dealerBranchCode").setValue(response.dealerBranchCode);
    this.dealerBranchAddEditForm.get("companyName").setValue(response.companyName);
    this.dealerBranchAddEditForm.get("branchName").setValue(response.branchName);
    this.dealerBranchAddEditForm.get("phoneNumber").setValue(response.phoneNumber);
    this.dealerBranchAddEditForm.get("accountTypeId").setValue(response.accountTypeId);
    this.dealerBranchAddEditForm.get("accountsEmailAddress").setValue(response.accountsEmailAddress);
    this.dealerBranchAddEditForm.get("adminEmailAddress").setValue(response.adminEmailAddress);
    this.dealerBranchAddEditForm.get("technicalEmailAddress").setValue(response.technicalEmailAddress);
    this.dealerBranchAddEditForm.get("emailAddress").setValue(response.emailAddress);
    this.dealerBranchAddEditForm.get("managerName").setValue(response.managerName);
    this.dealerBranchAddEditForm.get("managerSurname").setValue(response.managerSurname);
    this.dealerBranchAddEditForm.get("supportPhoneNumber").setValue(response.supportPhoneNumber);
    this.dealerBranchAddEditForm.get("isAuthorizedToRemoveRS").setValue(response.isAuthorizedToRemoveRS);
    // this.dealerBranchAddEditForm.get("bonusMultiple").setValue(response.bonusMultiple);
    // this.dealerBranchAddEditForm.get("debtorCode").setValue(response.debtorCode);
    // this.dealerBranchAddEditForm.get("sapVendorNumber").setValue(response.sapVendorNumber);
    // this.dealerBranchAddEditForm.get("bankAccountHolderName").setValue(response.bankAccountHolderName);
    this.dealerBranchAddEditForm.get("accountTypeId").setValue(response.accountTypeId);
    this.dealerBranchAddEditForm.get("bankAccountNumber").setValue(response.accountNo);
    this.dealerBranchAddEditForm.get("bankId").setValue(response.bankId);
    this.dealerBranchAddEditForm.get("bankBranchId").setValue(response.bankBranchId);
    // this.dealerBranchAddEditForm.get("isBankStatus").setValue(response.isBankStatus);
    this.dealerBranchAddEditForm.get("bankBranchCode").setValue(response.bankBranchCode);
    // this.dealerBranchAddEditForm.get("locationId").setValue(response.storageLocationName);
    // this.dealerBranchAddEditForm.get("techAreaId").setValue(response.techAreaId, { emitEvent: false, onlySelf: true });
    this.dealerBranchAddEditForm.get("techStockLocationId").setValue(response.techStockLocationId);
    // this.dealerBranchAddEditForm.get("warehouseId").setValue(response.warehouseName);
    this.dealerBranchAddEditForm.get("fullAddress").setValue({ description: response.formatedAddress });
    this.dealerBranchAddEditForm.get("buildingNo").setValue(response?.buildingNo);
    this.dealerBranchAddEditForm.get("buildingName").setValue(response?.buildingName);
    this.dealerBranchAddEditForm.get("streetNo").setValue(response.streetNo);
    this.dealerBranchAddEditForm.get("streetName").setValue(response.streetName);
    this.dealerBranchAddEditForm.get("suburbName").setValue(response.suburbName);
    this.dealerBranchAddEditForm.get("cityName").setValue(response.cityName);
    this.dealerBranchAddEditForm.get("provinceName").setValue(response.provinceName);
    this.dealerBranchAddEditForm.get("provinceId").setValue(response.provinceId);
    this.dealerBranchAddEditForm.get("postalCode").setValue(response.postalCode);
    this.dealerBranchAddEditForm.get('estateName').setValue(response.estateName);
    this.dealerBranchAddEditForm.get('estateStreetNo').setValue(response.estateStreetNo);
    this.dealerBranchAddEditForm.get('estateStreetName').setValue(response.estateStreetName);
    this.dealerBranchAddEditForm.get('isAddressComplex').setValue(response.isAddressComplex);
    this.dealerBranchAddEditForm.get('isAddressExtra').setValue(response.isAddressExtra);
    // this.dealerBranchAddEditForm.get("dsfMultiple").setValue(response.dsfMultiple);
    this.dealerBranchAddEditForm.get("isSameAsDealerAddress").setValue(response?.isSameAsDealerAddress, { emitEvent: false, onlySelf: true });
    // this.dealerBranchAddEditForm.get("commissionStartDate").setValue(new Date(response.commissionStartDate));
    // if (response.bonusMultipleStartDate) {
    //   this.dealerBranchAddEditForm.get("bonusMultipleStartDate").setValue(new Date(response.bonusMultipleStartDate));
    // }
    // this.dealerBranchAddEditForm.get("postalFullAddress").setValue({ description: response.postalFormatedAddress });
    // this.dealerBranchAddEditForm.get("postalBuildingNo").setValue(response?.postalBuildingNo);
    // this.dealerBranchAddEditForm.get("postalBuildingName").setValue(response?.postalBuildingName);
    // this.dealerBranchAddEditForm.get("postalStreetNo").setValue(response.postalStreetNo);
    // this.dealerBranchAddEditForm.get("postalStreetName").setValue(response.postalStreetName);
    // this.dealerBranchAddEditForm.get("postalSuburbName").setValue(response.postalSuburbName);
    // this.dealerBranchAddEditForm.get("postalCityName").setValue(response.postalCityName);
    // this.dealerBranchAddEditForm.get("postalProvinceName").setValue(response.postalProvinceName);
    // this.dealerBranchAddEditForm.get("postalPostalCode").setValue(response.postalPostalCode);
    this.dealerBranchAddEditForm.get("isSameAsPhysicalAddress").setValue(response.isSameAsPhysicalAddress, { emitEvent: false });

    this.dealerBranchAddEditForm.get("isLegalEntity").setValue(response.isLegalEntity);
    this.dealerBranchAddEditForm.get("isPerson").setValue(response.isPerson);
    this.dealerBranchAddEditForm.get("firstName").setValue(response.firstName);
    this.dealerBranchAddEditForm.get("lastName").setValue(response.lastName);
    this.dealerBranchAddEditForm.get("companyRegistrationNumber").setValue(response.companyRegistrationNumber);
    this.dealerBranchAddEditForm.get("southAfricanId").setValue(response.southAfricanId);
    this.dealerBranchAddEditForm.get("titleId").setValue(response.titleId);
    this.dealerBranchAddEditForm.get("debtorAccountDetailId").setValue(response?.debtorAccountDetailId);

    this.dealerBranchAddEditForm.get("postalAddressId").setValue(response.postalAddressId);
    this.dealerBranchAddEditForm.get("physicalAddressId").setValue(response.physicalAddressId);
    this.dealerBranchAddEditForm.get("latitude").setValue(response.latitude);
    this.dealerBranchAddEditForm.get("longitude").setValue(response.longitude);
    this.dealerBranchAddEditForm.get("postalLatitude").setValue(response.postalLatitude);
    this.dealerBranchAddEditForm.get("postalLongitude").setValue(response.postalLongitude);

    this.dealerBranchAddEditForm.get('postalAddress1').setValue(response.postalAddress1);
    this.dealerBranchAddEditForm.get('postalAddress2').setValue(response.postalAddress2);
    this.dealerBranchAddEditForm.get('postalAddress3').setValue(response.postalAddress3);
    this.dealerBranchAddEditForm.get('postalAddress4').setValue(response.postalAddress4);
    this.dealerBranchAddEditForm.get('postalAddress5').setValue(response.postalAddress5);
    this.techStockLocationNumber = response.techStockLocationNumber;
    if (response.isLegalEntity) {
      this.dealerBranchAddEditForm.get("isLegalEntityPerson").setValue(true, { emitEvent: false, onlySelf: true });
      this.setisLegalEntityPerson(true, true);
      this.dealerBranchDetails.isLegalEntityPerson = true
    }
    else {
      this.dealerBranchAddEditForm.get("isLegalEntityPerson").setValue(false, { emitEvent: false, onlySelf: true });
      this.setisLegalEntityPerson(false, true);
      this.dealerBranchDetails.isLegalEntityPerson = false
    }

  }
  onSelectedItemOption(
    isSelected: boolean,
    type: string,
    selectedObject: object
  ): void {

  }


  enableDisablePostalAddress(response) {
    if (response == true) {
      this.dealerBranchAddEditForm.get('postalFullAddress').disable({ emitEvent: false });
      this.dealerBranchAddEditForm.get('postalStreetNo').disable();
      this.dealerBranchAddEditForm.get('postalBuildingName').disable();
      this.dealerBranchAddEditForm.get('postalBuildingNo').disable();
    } else if (response == false) {
      this.dealerBranchAddEditForm.get('postalFullAddress').enable({ emitEvent: false });
      this.dealerBranchAddEditForm.get('postalStreetNo').enable();
      this.dealerBranchAddEditForm.get('postalBuildingName').enable();
      this.dealerBranchAddEditForm.get('postalBuildingNo').enable();
    }
  }
  filterServiceTypeDetailsBySearchOptions(searchValue?: string): Observable<IApplicationResponse> | any {
    this.checkMaxLengthPhysicalAddress = false;
    this.checkMaxLengthPostalAddress = false;
    if (searchValue.length < 3) {
      this.checkMaxLengthPhysicalAddress = true;
      this.checkMaxLengthPostalAddress = true;
      return of([]);
    } else {
      return this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_GET_ADDRESS_FROM_AFRIGIS, null, true, prepareGetRequestHttpParams(null, null, {
        searchtext: searchValue,
        IsAfrigisSearch: this.dealerBranchAddEditForm.get('isAfrigisSearch').value
      }), 1)
    }
  }
  setFormValidators() {
    this.dealerBranchAddEditForm = setRequiredValidator(this.dealerBranchAddEditForm,
      []);
  }

  onSelectedPhysicalAddressFromAutoComplete(value, address, seoid) {
    let afrigisAddressComponents: IAfrigisAddressComponents | any;
    this.inValidPostalAddress = false;
    if (this.dealerBranchAddEditForm.get('isAfrigisSearch').value) {
      this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_ADDRESS_DETAILS, undefined, false,
        prepareRequiredHttpParams({ seoid: seoid }), 1)
        .subscribe((res: IApplicationResponse) => {
          this.rxjsService.setGlobalLoaderProperty(false);
          if (res.resources) {
            this.postalAddressJsonAddress = JSON.stringify(res.resources);
            this.physicalAddressList = res.resources.addressDetails[0].formatted_address.split(',');
            // res.resources.addressDetails[0].formatted_address ? res.resources.addressDetails[0].formatted_address : [];
          }
          let latLong_details = res.resources.addressDetails[0].geometry;
          this.dealerBranchAddEditForm.patchValue({
            buildingNo: '', buildingName: '', streetNo: '', streetName: '', suburbName: '', cityName: '',
            provinceName: '', provinceId: '', postalCode: '', latitude: '', longitude: '', seoId: '', estateName: '',
            estateStreetNo: '', estateStreetName: '', jsonObject: '', addressConfidentLevelName: '', addressConfidentLevelId: ''
          })
          if (latLong_details) {
            // this.dealerMaintenanceAddEditForm.controls['locationPin'].setValue(latLong_details.location.lat + ',' + latLong_details.location.lng);
            this.dealerBranchAddEditForm.controls['latitude'].setValue(latLong_details.location.lat);
            this.dealerBranchAddEditForm.controls['longitude'].setValue(latLong_details.location.lng);
            let latLong = '';
            if (latLong_details?.location?.lat && latLong_details?.location?.lng) {
              latLong = `${latLong_details?.location?.lat}, ${latLong_details?.location?.lng}`;
            } else {
              latLong = "";
            }
            this.dealerBranchAddEditForm.get('latLong').setValue(latLong);
          }
          this.dealerBranchAddEditForm.get('seoId').setValue(res.resources.addressDetails[0].seoid);
          afrigisAddressComponents = destructureAfrigisObjectAddressComponents(res.resources.addressDetails[0].address_components);
          this.dealerBranchAddEditForm.patchValue({
            suburbName: afrigisAddressComponents.suburbName, cityName: afrigisAddressComponents.cityName,
            provinceId: afrigisAddressComponents.provinceId, provinceName: afrigisAddressComponents.provinceName, postalCode: afrigisAddressComponents.postalCode,
            streetName: afrigisAddressComponents.streetName, streetNo: afrigisAddressComponents.streetNo,
            buildingName: afrigisAddressComponents.buildingName, buildingNo: afrigisAddressComponents.buildingNo,
            estateName: afrigisAddressComponents?.estateName || '', estateStreetName: afrigisAddressComponents?.estateStreetName || '',
            estateStreetNo: afrigisAddressComponents?.estateStreetNo || '',
            addressConfidentLevelName: afrigisAddressComponents?.addressConfidentLevelName || '', addressConfidentLevelId: afrigisAddressComponents?.addressConfidentLevelId || '',
            jsonObject: JSON.stringify(res.resources),
          })
        })
    } else {
      const selectedObject = address;
      selectedObject["longitude"] = selectedObject["longitude"] ? selectedObject["longitude"] : "";
      selectedObject["latitude"] = selectedObject["latitude"] ? selectedObject["latitude"] : "";
      if (selectedObject["latitude"] && selectedObject["longitude"]) {
        selectedObject["latLong"] = `${selectedObject["latitude"]}, ${selectedObject["longitude"]}`;
      } else {
        selectedObject["latLong"] = "";
      }
      this.dealerBranchAddEditForm.patchValue({
        physicalAddressId: selectedObject['addressId'],
        seoid: "",
        jsonObject: "",
        latitude: selectedObject["latitude"],
        longitude: selectedObject["longitude"],
        latLong: selectedObject["latLong"],
        suburbName: selectedObject["suburbName"],
        cityName: selectedObject["cityName"],
        provinceName: selectedObject["provinceName"],
        provinceId: selectedObject["provinceId"],
        postalCode: selectedObject["postalCode"],
        streetName: selectedObject["streetName"],
        streetNo: selectedObject["streetNo"],
        estateName: selectedObject["estateName"],
        estateStreetName: selectedObject["estateStreetName"],
        estateStreetNo: selectedObject["estateStreetNo"],
        buildingName: selectedObject["buildingName"],
        buildingNo: selectedObject["buildingNo"],
        addressConfidentLevelName: selectedObject["addressConfidentLevelName"],
        addressConfidentLevelId: selectedObject["addressConfidentLevelId"]
      }, { emitEvent: false, onlySelf: true });
    }
  }
  onSelectedAddressFromAutoComplete(value, address, seoid) {
    let afrigisAddressComponents: IAfrigisAddressComponents;
    this.inValidPostalAddress = false;
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_ADDRESS_DETAILS, undefined, false,
      prepareRequiredHttpParams({ seoid: seoid }), 1)
      .subscribe((res: IApplicationResponse) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (res.resources) {
          this.postalAddressJsonAddress = JSON.stringify(res.resources);
          this.postalAddressList = res.resources.addressDetails[0].formatted_address.split(',');
        }
        let latLong_details = res.resources.addressDetails[0].geometry;
        this.dealerBranchAddEditForm.patchValue({
          postalBuildingNo: '', postalBuildingName: '', postalStreetNo: '', postalStreetName: '', postalSuburbName: '', postalCityName: '',
          postalProvinceName: '', postalPostalCode: '', postalLatitude: '', postalLongitude: '', postalseoId: '', postalEstateName: '',
          postalEstateStreetNo: '', postalEstateStreetName: '', postalJsonObject: ''
        })
        if (latLong_details) {
          // this.dealerMaintenanceAddEditForm.controls['locationPin'].setValue(latLong_details.location.lat + ',' + latLong_details.location.lng);
          this.dealerBranchAddEditForm.controls['postalLatitude'].setValue(latLong_details.location.lat);
          this.dealerBranchAddEditForm.controls['postalLongitude'].setValue(latLong_details.location.lng);
        }
        this.dealerBranchAddEditForm.get('postalseoId').setValue(res.resources.addressDetails[0].seoid);
        afrigisAddressComponents = destructureAfrigisObjectAddressComponents(res.resources.addressDetails[0].address_components);
        this.dealerBranchAddEditForm.patchValue({
          postalSuburbName: afrigisAddressComponents.suburbName, postalCityName: afrigisAddressComponents.cityName,
          postalProvinceName: afrigisAddressComponents.provinceName, postalPostalCode: afrigisAddressComponents.postalCode,
          postalStreetName: afrigisAddressComponents.streetName, postalStreetNo: afrigisAddressComponents.streetNo,
          postalBuildingName: afrigisAddressComponents.buildingName, postalBuildingNo: afrigisAddressComponents.buildingNo,
          postalJsonObject: JSON.stringify(res.resources),
        })
      })
  }

  setEmptyPhysicalAddress(desc = '') {
    this.physicalAddressList = [];
    this.inValidPhysicalAddress = true;
    this.dealerBranchAddEditForm.get('seoId').setValue('');
    this.dealerBranchAddEditForm.get('latitude').setValue('');
    this.dealerBranchAddEditForm.get('longitude').setValue('');
    this.dealerBranchAddEditForm.get('latLong').setValue('');
    this.dealerBranchAddEditForm.get('jsonObject').setValue('');
    if (desc) {
      this.setEmptyAddressMsg(desc);
    }
  }

  setEmptyPostalAddress(desc = '') {
    this.postalAddressList = [];
    this.inValidPostalAddress = true;
    this.dealerBranchAddEditForm.get('postalseoId').setValue('');
    this.dealerBranchAddEditForm.get('postalLatitude').setValue('');
    this.dealerBranchAddEditForm.get('postalLongitude').setValue('');
    this.dealerBranchAddEditForm.get('postalJsonObject').setValue('');
    if (desc) {
      this.setEmptyAddressMsg(desc);
    }
  }

  setEmptyAddressMsg(desc) {
    this.snackbarService.openSnackbar(desc, ResponseMessageTypes.ERROR);
    return;
  }


  openAddressPopup(addType?) {
    const data = {
      createdUserId: this.userData?.userId,
      modifiedUserId: this.userData?.userId,
      isAddressExtra: this.dealerBranchAddEditForm.get('isAddressExtra').value,
      isAddressComplex: this.dealerBranchAddEditForm.get('isAddressComplex').value,
      mobile2: null, officeNo: null, mobile1: null, premisesNo: null, isShowAddressType: false,
      formatedAddress: addType == 'physical' ? this.dealerBranchAddEditForm.get('fullAddress').value?.description : this.dealerBranchAddEditForm.get('postalFullAddress').value?.description,
    }
    const dialogReff = this.dialog.open(NewAddressPopupComponent, {
      width: "750px",
      disableClose: true,
      data: data,
    });

    dialogReff.afterClosed().subscribe((result) => { });
    dialogReff.componentInstance.outputData.subscribe((ele) => {
      if (ele) {
        const fullAddress = ele.streetNo + ',' + ele.streetName + ',' + ele.suburbName + ',' + ele.cityName + ',' + ele.provinceName + ',' + ele.postalCode;
        if (addType == 'physical') {
          this.dealerBranchAddEditForm.get("fullAddress").setValue({ description: fullAddress });
          this.dealerBranchAddEditForm.get("buildingNo").setValue(ele?.buildingNo);
          this.dealerBranchAddEditForm.get("buildingName").setValue(ele?.buildingName);
          this.dealerBranchAddEditForm.get("streetNo").setValue(ele.streetNo);
          this.dealerBranchAddEditForm.get("streetName").setValue(ele.streetName);
          this.dealerBranchAddEditForm.get("suburbName").setValue(ele.suburbName);
          this.dealerBranchAddEditForm.get("cityName").setValue(ele.cityName);
          this.dealerBranchAddEditForm.get("provinceName").setValue(ele.provinceName);
          this.dealerBranchAddEditForm.get("provinceId").setValue(ele.provinceId);
          this.dealerBranchAddEditForm.get("postalCode").setValue(ele.postalCode);
          this.dealerBranchAddEditForm.get("latitude").setValue('');
          this.dealerBranchAddEditForm.get("longitude").setValue('');
          this.dealerBranchAddEditForm.get("latLong").setValue('');
          this.dealerBranchAddEditForm.get("seoId").setValue('');
          this.dealerBranchAddEditForm.get("jsonObject").setValue('');
          this.dealerBranchAddEditForm.get("estateName").setValue(ele.estateName);
          this.dealerBranchAddEditForm.get("estateStreetNo").setValue(ele.estateStreetNo);
          this.dealerBranchAddEditForm.get("estateStreetName").setValue(ele.estateStreetName);
          this.dealerBranchAddEditForm.get("addressConfidentLevelName").setValue(ele?.addressConfidentLevelName || '');
          this.dealerBranchAddEditForm.get("addressConfidentLevelId").setValue(ele?.addressConfidentLevelId || '');
        } else {
          this.dealerBranchAddEditForm.get("postalFullAddress").setValue({ description: fullAddress });
          this.dealerBranchAddEditForm.get("postalBuildingNo").setValue(ele?.buildingNo);
          this.dealerBranchAddEditForm.get("postalBuildingName").setValue(ele?.buildingName);
          this.dealerBranchAddEditForm.get("postalStreetNo").setValue(ele.streetNo);
          this.dealerBranchAddEditForm.get("postalStreetName").setValue(ele.streetName);
          this.dealerBranchAddEditForm.get("postalSuburbName").setValue(ele.suburbName);
          this.dealerBranchAddEditForm.get("postalCityName").setValue(ele.cityName);
          this.dealerBranchAddEditForm.get("postalProvinceName").setValue(ele.provinceName);
          this.dealerBranchAddEditForm.get("postalPostalCode").setValue(ele.postalCode);
          this.dealerBranchAddEditForm.get("postalLatitude").setValue('');
          this.dealerBranchAddEditForm.get("postalLongitude").setValue('');
          this.dealerBranchAddEditForm.get("postalseoId").setValue('');
          this.dealerBranchAddEditForm.get("postalJsonObject").setValue('');
          this.dealerBranchAddEditForm.get("postalEstateName").setValue(ele.estateName);
          this.dealerBranchAddEditForm.get("postalEstateStreetNo").setValue(ele.estateStreetNo);
          this.dealerBranchAddEditForm.get("postalEstateStreetName").setValue(ele.estateStreetName);
        }

      }
    });
  }

  onSubmit(skipBankingValidation = false) {
    this.dealerBranchAddEditForm.markAsUntouched();
    if (this.dealerBranchAddEditForm.invalid) {
      this.dealerBranchAddEditForm.markAllAsTouched();
      return;
    }

    let formValue = this.dealerBranchAddEditForm.getRawValue();
    formValue.startDate = (formValue.startDate && formValue.startDate != null) ? this.momentService.toMoment(formValue.startDate).format('YYYY-MM-DDThh:mm:ss[Z]') : null;
    formValue.endDate = (formValue.endDate && formValue.endDate != null) ? this.momentService.toMoment(formValue.endDate).format('YYYY-MM-DDThh:mm:ss[Z]') : null;
    // formValue.commissionStartDate = (formValue.commissionStartDate && formValue.commissionStartDate != null) ? this.momentService.toMoment(formValue.commissionStartDate).format('YYYY-MM-DDThh:mm:ss[Z]') : null;
    // formValue.bonusMultipleStartDate = (formValue.bonusMultipleStartDate && formValue.bonusMultipleStartDate != null) ? this.momentService.toMoment(formValue.bonusMultipleStartDate).format('YYYY-MM-DDThh:mm:ss[Z]') : null;

    let finalObject = {
      dealerBranchId: this.dealerBranchId ? this.dealerBranchId : null,
      isSameAsDealerAddress: formValue.isSameAsDealerAddress || false,
      dealerId: this.dealerId,
      startDate: formValue.startDate,
      endDate: formValue.endDate,
      companyName: formValue.companyName,
      branchName: formValue.branchName,
      phoneNumber: formValue.phoneNumber,
      dealerBranchPhysicalAddress: {
        addressId: formValue.physicalAddressId,
        buildingName: formValue.buildingName,
        buildingNo: formValue.buildingNo,
        streetNo: formValue.streetNo,
        streetName: formValue.streetName,
        estateName: formValue.estateName,
        estateStreetNo: formValue.estateStreetNo,
        estateStreetName: formValue.estateStreetName,
        addressConfidentLevelName: formValue.addressConfidentLevelName,
        formatedAddress: formValue.fullAddress,
        jsonObject: formValue.jsonObject,
        seoId: formValue.seoId,
        postalCode: formValue.postalCode,
        latitude: formValue.latitude,
        longitude: formValue.longitude,
        latLong: formValue.latLong,
        addressConfidentLevelId: formValue.addressConfidentLevelId ? formValue.addressConfidentLevelId : null,
        isAddressComplex: formValue.isAddressComplex ? formValue.isAddressComplex : false,
        isAddressExtra: formValue.isAddressExtra ? formValue.isAddressExtra : false,
        afriGISAddressId: formValue.afriGISAddressId,
        suburbName: formValue.suburbName,
        cityName: formValue.cityName,
        provinceName: formValue.provinceName,
        provinceId: formValue.provinceId,
      },
      isSameAsPhysicalAddress: formValue.isSameAsPhysicalAddress ? true : false,
      postalAddress1: formValue?.postalAddress1,
      postalAddress2: formValue?.postalAddress2,
      postalAddress3: formValue?.postalAddress3,
      postalAddress4: formValue?.postalAddress4,
      postalAddress5: formValue?.postalAddress5,
      dealerBranchPostalAddress: {
        addressId: formValue.postalAddressId,
        buildingName: formValue.postalBuildingName,
        buildingNo: formValue.postalBuildingNo,
        streetNo: formValue.postalStreetNo,
        streetName: formValue.postalStreetName,
        estateName: formValue.postalEstateName,
        estateStreetNo: formValue.postalEstateStreetNo,
        estateStreetName: formValue.postalEstateStreetName,
        addressConfidentLevelName: formValue.postalAddressConfidentLevelName,
        formatedAddress: formValue.postalFullAddress,
        jsonObject: formValue.postalJsonObject,
        seoId: formValue.postalseoId,
        postalCode: formValue.postalCode,
        latitude: formValue.postalLatitude,
        longitude: formValue.postalLongitude,
        addressConfidentLevelId: formValue.postalAddressConfidentLevelId ? formValue.postalAddressConfidentLevelId : null,
        isAddressComplex: formValue.postalIsAddressComplex ? formValue.postalIsAddressComplex : false,
        isAddressExtra: formValue.postalIsAddressExtra ? formValue.postalIsAddressExtra : false,
        afriGISAddressId: formValue.postalAfriGISAddressId,
        suburbName: formValue.postalSuburbName,
        cityName: formValue.postalCityName,
        provinceName: formValue.postalProvinceName,
      },
      emailAddress: formValue.emailAddress,
      adminEmailAddress: formValue.adminEmailAddress,
      accountsEmailAddress: formValue.accountsEmailAddress,
      technicalEmailAddress: formValue.technicalEmailAddress,
      managerName: formValue.managerName,
      managerSurname: formValue.managerSurname,
      supportPhoneNumber: formValue.supportPhoneNumber,
      isAuthorizedToRemoveRS: formValue.isAuthorizedToRemoveRS ? true : false,
      // dealerCategoryTypeId: formValue.dealerCategoryTypeId,
      // commissionStartDate: formValue.commissionStartDate,
      // bonusMultipleStartDate: formValue.bonusMultipleStartDate,
      // bonusMultiple: formValue.bonusMultiple,
      // debtorCode: formValue.debtorCode,
      // sapVendorNumber: formValue.sapVendorNumber,
      // dsfMultiple: formValue.dsfMultiple,
      // bankAccountHolderName: formValue.bankAccountHolderName,
      isLegalEntity: formValue.isLegalEntityPerson.toString() == 'true' ? true : false,
      isPerson: formValue.isLegalEntityPerson.toString() == 'false' ? true : false,
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      companyRegistrationNumber: formValue.companyRegistrationNumber,
      southAfricanId: formValue.southAfricanId,
      titleId: formValue.titleId ? Number(formValue.titleId) : null,
      accountTypeId: formValue.accountTypeId,
      accountNo: formValue.bankAccountNumber,
      bankId: formValue.bankId,
      bankBranchId: formValue.bankBranchId,
      // isBankStatus: formValue.isBankStatus ? true : false,
      // locationId: this.locationId,
      // techAreaId: formValue.techAreaId,
      techStockLocationId: this.techStocklocationId,
      // WarehouseId: this.wareHouseId,
      isDraft: true,
      // isActive: true,
      createdUserId: this.userData.userId,
      isExistingDebtor: formValue.isExistingDebtor || false,
      debtorId: formValue.debtorId,
      debtorAccountDetailId: formValue.debtorAccountDetailId,
    }
    if (skipBankingValidation) {
      finalObject['skipBankingValidation'] = true;
    }
    if (typeof finalObject['dealerBranchPhysicalAddress']?.formatedAddress == 'object') {
      finalObject['dealerBranchPhysicalAddress'].formatedAddress = finalObject['dealerBranchPhysicalAddress']?.formatedAddress?.description;
    }
    if (typeof finalObject['dealerBranchPostalAddress']?.formatedAddress == 'object') {
      finalObject['dealerBranchPostalAddress'].formatedAddress = finalObject['dealerBranchPostalAddress']?.formatedAddress?.description;
    }
    finalObject['dealerBranchPhysicalAddress']['createdUserId'] = this.userData?.userId;
    finalObject['dealerBranchPostalAddress']['createdUserId'] = this.userData?.userId;
    let api = this.dealerBranchId ? this.crudService.update(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH, finalObject) :
      this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH, finalObject, 1);
    api.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.router.navigate(['dealer/dealer-maintenance'],
          { queryParams: { tab: 2, id: this.dealerId, dealerTypeId: this.dealerTypeId } });
      } else {
        if (response.message.includes("linked to another customer")) {
          this.openDebterExistModal(response.resources);
        }
      }
      this.rxjsService.setDialogOpenProperty(false);
    });

  }
  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: number | string): void {
    switch (type) { }
  }
}
